import * as React from 'react'
import Footer from './Footer'
import Header from './Header'
import FooterClever from './FooterClever'
import HeaderClever from './HeaderClever'
import MainRoutes from '../../MainRoutes'
import GlobalStyle from './GlobalStyle'

// Storing the scroll position is important as when the page is
// reloaded and users are not at the very top of the page they
// will find themselves at the very bottom after the configurator
// has finished loading. This problem only occurs on sepcific
// browsers (e.g. Chrome).

export default function Layout(props) {
  console.log(props.history.location.pathname)
  const saveScrollPosition = () => {
    window.sessionStorage.setItem(
      'scrollPosition',
      `${document.body.getBoundingClientRect().top}`
    )
  }

  React.useEffect(() => {
    window.addEventListener('unload', saveScrollPosition)
    return () => window.removeEventListener('unload', saveScrollPosition)
  })

  return (
    <div>
      <GlobalStyle />
      {props.history.location.pathname.indexOf('/clever/') < 0 ? <Header /> : <HeaderClever/>}
      <MainRoutes />
      {props.history.location.pathname.indexOf('/clever/') < 0 ? <Footer /> : <FooterClever />}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/layout/Layout.tsx